/* Bellisa size tools: "Size Chart" pop-up + "Find my size" quiz.
   Chart numbers: snippets/bellisa-size-charts.liquid. Product data: snippets/bellisa-size-tools.liquid. */
(function () {
  if (window.BellisaSizeTools) return;

  var STORE_KEY = 'bellisa_size_profile_v1';
  var CM_PER_IN = 2.54;
  var KG_PER_LB = 0.45359237;

  /* ---------- helpers ---------- */
  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (k === 'class') e.className = attrs[k];
      else if (k === 'text') e.textContent = attrs[k];
      else e.setAttribute(k, attrs[k]);
    }
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function load() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function save(p) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(p)); } catch (e) {}
  }
  var charts = null;
  function getCharts() {
    if (charts) return charts;
    var s = document.getElementById('bellisa-size-charts');
    try { charts = JSON.parse(s.textContent); } catch (e) { charts = null; }
    return charts;
  }

  /* ---------- size labels ---------- */
  var ALIAS = {
    XXS: '2XS', XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', XXXXXL: '5XL',
    SMALL: 'S', MEDIUM: 'M', LARGE: 'L', 'X-LARGE': 'XL', XLARGE: 'XL', 'EXTRA LARGE': 'XL',
    'X-SMALL': 'XS', XSMALL: 'XS'
  };
  var LETTER = /^(\d?X{0,5}[SML]|XS|XL|\dXL|\dXS)$/;
  // Turn a product's size value ("XXL", "8 (S)", "UK 12/14 (L)", "S 8–10") into a chart size ("2XL", "S", "L").
  function letterOf(label) {
    var s = String(label).toUpperCase().trim();
    var paren = s.match(/\(([^)]+)\)/);
    if (paren && LETTER.test(normal(paren[1]))) return normal(paren[1]);
    var first = s.split(/[\s\/|]+/)[0];
    if (LETTER.test(normal(first))) return normal(first);
    if (LETTER.test(normal(s))) return normal(s);
    return null;
    function normal(x) { x = x.trim(); return ALIAS[x] || x; }
  }
  // UK numbers written in a clothing size label: "S 8–10" -> [8,10], "UK 12/14 (L)" -> [12,14], "XS (6)" -> [6], "2XL" -> null.
  function ukOfLabel(label) {
    var s = String(label).toUpperCase().replace(/\(([^)]*)\)/g, ' $1 ');
    var rest = s.split(/\s+/).filter(function (t) { return t && t !== 'UK' && !LETTER.test(ALIAS[t] || t); }).join(' ');
    var m = rest.match(/(\d{1,2})(?:\s*[-–\/]\s*(\d{1,2}))?/);
    if (!m) return null;
    var a = +m[1], b = m[2] ? +m[2] : null;
    if (a < 2 || a > 32) return null;
    return b && b > a ? [a, b] : [a];
  }
  // Shoe values ("UK 6 | EU 39", "6 (36 Eu)", "38") -> "UK 6"
  function shoeOf(label) {
    var s = String(label).toUpperCase();
    var uk = s.match(/UK\s*(\d+(\.5)?)/);
    if (uk) return 'UK ' + uk[1];
    var n = s.match(/^(\d+(\.5)?)/);
    if (n && +n[1] < 15) return 'UK ' + n[1];
    return null;
  }

  /* ---------- category ---------- */
  function categoryOf(prod) {
    var o = String(prod.override || '').toLowerCase().trim();
    if (o) return o;
    var t = String(prod.type || '').toLowerCase();
    if (/boot|heel|sandal|sneaker|trainer|loafer|flat|espadrille|shoe|mule|pump/.test(t)) return 'footwear';
    if (/bag|tote|clutch|sunglass|glove|scarf|hat|beanie|organi[sz]er|appliance|jewel|belt/.test(t)) return 'none';
    if (/coat|jacket|blazer|gilet|puffer|trench|outerwear|parka|shacket/.test(t)) return 'outerwear';
    if (/dress|jumpsuit|playsuit|skirt|trouser|pant|jean|legging|short|set|lounge|co-ord|outfit/.test(t)) return 'dresses';
    var shoe = (prod.sizes || []).filter(function (v) { return shoeOf(v) && !letterOf(v); }).length;
    if (shoe && shoe === (prod.sizes || []).length) return 'footwear';
    return 'tops';
  }

  // Chart rows to show for this product: the sizes it sells (or the full chart if they don't line up).
  function rowsFor(prod, cat) {
    var c = getCharts()[cat];
    if (!c) return [];
    var mapFn = cat === 'footwear' ? shoeOf : letterOf;
    var sold = {};
    (prod.sizes || []).forEach(function (v) { var k = mapFn(v); if (k) sold[k] = v; });
    var rows = c.rows.map(function (r) {
      var row = Object.assign({}, r, { value: sold[r.size] || null });
      // If the product's own label states a UK size ("S 8–10", "UK 12/14 (L)", "XS (6)"), use it so the chart matches the buttons.
      var own = row.value && cat !== 'footwear' ? ukOfLabel(row.value) : null;
      if (own) {
        // Take the body measurements from the chart row that covers the label's largest UK size.
        var top = own[own.length - 1];
        for (var i = 0; i < c.rows.length; i++) {
          var rr = String(c.rows[i].uk).split(/[-–]/).map(Number);
          if (top <= rr[rr.length - 1]) { ['bust', 'waist', 'hips'].forEach(function (k) { if (c.rows[i][k] != null) row[k] = c.rows[i][k]; }); break; }
        }
        row.uk = own.join('-');
        row.us = own.map(function (n) { return Math.max(0, n - 4); }).join('-');
        row.eu = own.map(function (n) { return n + 28; }).join('-');
      }
      return row;
    });
    if (cat === 'footwear') return rows;
    var matched = rows.filter(function (r) { return r.value; });
    return matched.length >= 2 ? matched : rows;
  }

  /* ---------- recommendation ---------- */
  // Estimated UK dress size from height and weight, then adjusted for fit and hip shape.
  // Product fit setting (custom.fit_scale): -1 runs large, 0 true to size, +1 runs small.
  function fitShift(prod) {
    var f = String(prod.fit || '').toLowerCase();
    return /small/.test(f) ? 1 : /large/.test(f) ? -1 : 0;
  }
  function estimateUK(p, cat) {
    var m = p.h / 100, bmi = p.w / (m * m);
    var steps = [[18.5, 6], [20.5, 8], [22, 10], [24, 12], [26, 14], [28, 16], [30.5, 18], [33, 20], [35.5, 22], [38, 24]];
    var uk = 26;
    for (var i = 0; i < steps.length; i++) if (bmi < steps[i][0]) { uk = steps[i][1]; break; }
    if (p.fit === 'fitted') uk -= 1;
    if (p.fit === 'relaxed') uk += 2;
    if (cat === 'dresses') {
      if (p.hips === 'straight') uk -= 1;
      if (p.hips === 'fuller') uk += 2;
    }
    return uk;
  }
  function ukRange(r) {
    var n = String(r.uk).split(/[-–]/).map(Number);
    return [n[0], n[n.length - 1]];
  }
  function byMeasure(p) { return p.mode === 'measure'; }
  function profileDone(p, cat) {
    var base = byMeasure(p) ? (p.b && p.wa) : (p.h && p.w);
    return !!(base && p.fit && (cat !== 'dresses' || byMeasure(p) || p.hips));
  }
  function recommend(prod, cat, p) {
    var rows = rowsFor(prod, cat).filter(function (r) { return r.value || cat === 'footwear'; });
    if (!rows.length) rows = rowsFor(prod, cat);
    var shift = fitShift(prod), i;
    if (byMeasure(p) && p.b && p.wa) {
      // Smallest size whose chart measurements fit the shopper's bust, waist and (if given) hips.
      var idx = -1;
      for (i = 0; i < rows.length; i++) {
        var r = rows[i];
        if (p.b <= r.bust && p.wa <= r.waist && (!r.hips || !p.hi || p.hi <= r.hips)) { idx = i; break; }
      }
      var over = idx === -1;
      if (over) idx = rows.length - 1;
      if (p.fit === 'relaxed') idx++;
      idx += shift;
      var clamped = Math.max(0, Math.min(rows.length - 1, idx));
      return { row: rows[clamped], closest: over || clamped !== idx, shift: shift };
    }
    var uk = estimateUK(p, cat) + shift * 2;
    for (i = 0; i < rows.length; i++) {
      var rg = ukRange(rows[i]);
      if (uk <= rg[1]) return { row: rows[i], closest: i === 0 && uk < rg[0] - 2, uk: uk, shift: shift };
    }
    return { row: rows[rows.length - 1], closest: true, uk: uk, shift: shift };
  }

  /* ---------- formatting ---------- */
  function fmtHeight(cm, imperial) {
    if (!imperial) return Math.round(cm) + ' cm';
    var inches = Math.round(cm / CM_PER_IN), ft = Math.floor(inches / 12);
    return ft + '′' + (inches - ft * 12) + '″';
  }
  function fmtWeight(kg, imperial) {
    if (!imperial) return Math.round(kg) + ' kg';
    var lb = Math.round(kg / KG_PER_LB), st = Math.floor(lb / 14);
    return st + ' st ' + (lb - st * 14) + ' lb';
  }
  function fmtMeasure(cm, unit) {
    if (cm == null || cm === '') return '–';
    if (typeof cm === 'string') return esc(cm);
    return unit === 'in' ? (cm / CM_PER_IN).toFixed(1) : String(cm);
  }
  function fmtLen(cm, unit) {
    return unit === 'in' ? (Math.round(cm / CM_PER_IN * 2) / 2) + '″' : Math.round(cm) + ' cm';
  }
  var FIT_LABEL = { fitted: 'fitted fit', regular: 'regular fit', relaxed: 'relaxed fit' };
  var HEAD = { uk: 'UK', us: 'US', eu: 'EU', bust: 'Bust', waist: 'Waist', hips: 'Hips', foot: 'Foot length' };

  // "Runs small · True to size · Runs large" bar; only shown when the product has a fit set.
  function fitBar(prod) {
    var s = fitShift(prod);
    if (!prod.fit) return '';
    var pos = s === 1 ? 0 : s === -1 ? 2 : 1;
    var labels = ['Runs small', 'True to size', 'Runs large'];
    return '<div class="bst-fit" role="img" aria-label="Fit: ' + labels[pos] + '">' +
      '<div class="bst-fit__track"><span class="bst-fit__dot" style="left:' + (pos * 50) + '%"></span></div>' +
      '<div class="bst-fit__labels">' + labels.map(function (l, i) {
        return '<span' + (i === pos ? ' class="is-on"' : '') + '>' + l + '</span>';
      }).join('') + '</div></div>';
  }

  /* ---------- tracking: GA4 / dataLayer / Shopify customer events + a note on the order ---------- */
  function track(name, data) {
    data = Object.assign({ product: current && current.prod.title, category: current && current.cat }, data || {});
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'bellisa_' + name }, data)); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'bellisa_' + name, data); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('bellisa_' + name, data); } catch (e) {}
  }
  function cartNote(attrs) {
    try {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
    } catch (e) {}
  }

  /* ---------- dialog ---------- */
  var dlg, current; // current = { prod, cat, root }
  function dialog() {
    if (dlg) return dlg;
    dlg = el('dialog', { class: 'bst-dialog', 'aria-labelledby': 'bst-title' });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { // close only when the click lands outside the box (on the backdrop)
        var r = dlg.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
      }
      var a = e.target.closest('[data-bst-action]');
      if (a) action(a.getAttribute('data-bst-action'), a);
    });
    dlg.addEventListener('input', function (e) {
      if (e.target.matches('[data-bst-range]')) onRange(e.target);
    });
    document.body.appendChild(dlg);
    return dlg;
  }
  function open(view) {
    var d = dialog();
    render(view);
    if (!d.open) {
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    }
  }
  function header(title) {
    var p = current.prod;
    return '<div class="bst-head"><h2 id="bst-title">' + esc(title) + '</h2>' +
      '<button type="button" class="bst-close" data-bst-action="close" aria-label="Close">×</button></div>' +
      '<div class="bst-product">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" width="48" height="64">' : '') +
      '<span>' + esc(p.title) + '</span></div>';
  }
  function render(view) {
    var p = load(), html = '';
    if (view === 'chart') html = viewChart(p);
    else if (view === 'body') html = viewBody(p);
    else if (view === 'measure') html = viewMeasure(p);
    else if (view === 'fit') html = viewFit();
    else if (view === 'hips') html = viewHips();
    else if (view === 'result') html = viewResult(p);
    dlg.innerHTML = html;
    dlg.setAttribute('data-view', view);
    var f = dlg.querySelector('[data-bst-autofocus]') || dlg.querySelector('.bst-close');
    if (f) f.focus();
  }

  /* ---------- this item's own garment measurements (product metafield custom.garment_chart) ---------- */
  function garment(prod) {
    var g = prod.garment;
    if (!g || !g.headers || !g.rows || !g.rows.length) return null;
    var si = 0;
    g.headers.forEach(function (h, i) { if (/^size$/i.test(String(h).trim())) si = i; });
    var sold = {};
    (prod.sizes || []).forEach(function (v) { var k = letterOf(v); if (k) sold[k] = 1; });
    var rows = g.rows.filter(function (r) { return sold[letterOf(r[si]) || r[si]]; });
    return { unit: g.unit === 'cm' ? 'cm' : 'in', kind: g.kind === 'body' ? 'body' : 'garment', headers: g.headers, rows: rows.length >= 2 ? rows : g.rows };
  }
  function isLengthHead(h) { return !/size|^\s*(uk|us|eu|it|fr|au)\s*$/i.test(String(h)); }
  function convertText(v, from, to) {
    v = String(v == null ? '' : v);
    if (from === to) return esc(v);
    return esc(v.replace(/\d+(\.\d+)?/g, function (n) {
      n = parseFloat(n);
      return to === 'cm' ? String(Math.round(n * CM_PER_IN)) : (Math.round(n / CM_PER_IN * 10) / 10).toFixed(1);
    }));
  }
  function itemTable(g, unit) {
    return '<table class="bst-table"><thead><tr>' + g.headers.map(function (h) { return '<th scope="col">' + esc(h) + '</th>'; }).join('') +
      '</tr></thead><tbody>' + g.rows.map(function (r) {
        return '<tr>' + r.map(function (v, i) {
          var cell = isLengthHead(g.headers[i]) ? convertText(v, g.unit, unit) : esc(v);
          return i === 0 ? '<th scope="row">' + cell + '</th>' : '<td>' + cell + '</td>';
        }).join('') + '</tr>';
      }).join('') + '</tbody></table>';
  }

  function viewChart(p) {
    var cat = current.cat, c = getCharts(), chart = c[cat];
    var g = garment(current.prod);
    var tab = p.chartTab || (g ? 'item' : 'measure');
    if (tab === 'item' && !g) tab = 'measure';
    if (tab === 'intl' && !chart.intl) tab = 'measure';
    var unit = p.chartUnit === 'in' || p.chartUnit === 'cm' ? p.chartUnit : (tab === 'item' && g ? g.unit : 'cm');
    var rows = rowsFor(current.prod, cat);
    var intl = tab === 'intl';
    var cols = (intl ? chart.intl : chart.columns).filter(function (k) { return !(cat === 'footwear' && k === 'uk'); });
    var lengthCols = { bust: 1, waist: 1, hips: 1, foot: 1 };
    var t = '<table class="bst-table"><thead><tr><th scope="col">' + (cat === 'footwear' ? 'UK' : 'Size') + '</th>' +
      cols.map(function (k) { return '<th scope="col">' + HEAD[k] + '</th>'; }).join('') + '</tr></thead><tbody>' +
      rows.map(function (r) {
        return '<tr><th scope="row">' + esc(cat === 'footwear' ? r.size.replace('UK ', '') : r.size) + '</th>' +
          cols.map(function (k) {
            return '<td>' + (lengthCols[k] ? fmtMeasure(r[k], unit) : esc(r[k] != null ? r[k] : '–')) + '</td>';
          }).join('') + '</tr>';
      }).join('') + '</tbody></table>';
    var how = intl ? '' : cols.filter(function (k) { return c.howToMeasure[k]; }).map(function (k) {
      return '<p><strong>' + HEAD[k] + ':</strong> ' + esc(c.howToMeasure[k]) + '</p>';
    }).join('');
    var tabList = [];
    if (g) tabList.push(['item', 'This item']);
    tabList.push(['measure', g ? 'Body measurements' : 'Measurements']);
    if (chart.intl) tabList.push(['intl', 'UK · US · EU sizes']);
    var tabs = tabList.length > 1 ? '<div class="bst-tabs" role="tablist">' + tabList.map(function (t) {
      return '<button type="button" role="tab" data-bst-action="tab-' + t[0] + '" aria-selected="' + (tab === t[0]) + '">' + t[1] + '</button>';
    }).join('') + '</div>' : '';
    var item = tab === 'item';
    if (item) { t = itemTable(g, unit); how = ''; }
    return header('Size guide') + fitBar(current.prod) +
      '<h3 class="bst-sub">' + (item ? (g.kind === 'garment' ? 'Garment measurements' : 'Size chart for this item') : esc(chart.title) + ' size chart') + '</h3>' +
      '<p class="bst-note">' + (item ? (g.kind === 'garment'
          ? 'These are measurements of the garment itself, not body measurements. Compare with a similar piece you own. Between sizes? Choose the larger one.'
          : 'Body measurements this item is made to fit. Between sizes? Choose the larger one.')
        : esc(cat === 'footwear' ? c.notes.footwear : c.notes['default'])) + '</p>' + tabs +
      (intl ? '' : '<div class="bst-toggle" role="group" aria-label="Units">' +
      '<button type="button" data-bst-action="unit-cm" aria-pressed="' + (unit === 'cm') + '">cm</button>' +
      '<button type="button" data-bst-action="unit-in" aria-pressed="' + (unit === 'in') + '">inches</button></div>') +
      '<div class="bst-table-wrap">' + t + '</div>' +
      '<div class="bst-how">' + how + '</div>' +
      (cat !== 'footwear' ? '<button type="button" class="bst-btn" data-bst-action="find">Not sure? Find my size</button>' : '');
  }

  function viewBody(p) {
    var imp = p.bodyUnit !== 'metric';
    var h = p.h || 165, w = p.w || 65;
    return header('Find your size') +
      '<p class="bst-step">Step 1 of ' + (current.cat === 'dresses' ? 3 : 2) + '</p><h3 class="bst-q">Your height and weight</h3>' +
      '<div class="bst-toggle" role="group" aria-label="Units">' +
      '<button type="button" data-bst-action="body-metric" aria-pressed="' + !imp + '">cm / kg</button>' +
      '<button type="button" data-bst-action="body-imperial" aria-pressed="' + imp + '">ft / st</button></div>' +
      slider('h', 'Height', h, 140, 200, 1, fmtHeight(h, imp)) +
      slider('w', 'Weight', w, 40, 150, 1, fmtWeight(w, imp)) +
      '<button type="button" class="bst-btn" data-bst-action="body-next" data-bst-autofocus>Next</button>' +
      '<button type="button" class="bst-link-btn" data-bst-action="measure">I know my measurements</button>';
  }
  function viewMeasure(p) {
    var unit = p.measUnit === 'in' ? 'in' : 'cm';
    var b = p.b || 90, wa = p.wa || 72, hi = p.hi || 98;
    return header('Find your size') +
      '<p class="bst-step">Step 1 of 2</p><h3 class="bst-q">Your measurements</h3>' +
      '<div class="bst-toggle" role="group" aria-label="Units">' +
      '<button type="button" data-bst-action="meas-cm" aria-pressed="' + (unit === 'cm') + '">cm</button>' +
      '<button type="button" data-bst-action="meas-in" aria-pressed="' + (unit === 'in') + '">inches</button></div>' +
      slider('b', 'Bust', b, 70, 150, 1, fmtLen(b, unit)) +
      slider('wa', 'Waist', wa, 50, 140, 1, fmtLen(wa, unit)) +
      slider('hi', 'Hips', hi, 75, 160, 1, fmtLen(hi, unit)) +
      '<p class="bst-hint">Measure over underwear with the tape snug, not tight.</p>' +
      '<button type="button" class="bst-btn" data-bst-action="measure-next" data-bst-autofocus>Next</button>' +
      '<button type="button" class="bst-link-btn" data-bst-action="find-edit">Use height &amp; weight instead</button>';
  }
  function slider(key, label, val, min, max, step, shown) {
    return '<div class="bst-slider"><div class="bst-slider__top"><label for="bst-' + key + '">' + label + '</label>' +
      '<output id="bst-' + key + '-out" for="bst-' + key + '">' + shown + '</output></div>' +
      '<div class="bst-slider__row"><button type="button" class="bst-step-btn" data-bst-action="dec-' + key + '" aria-label="Decrease ' + label.toLowerCase() + '">−</button>' +
      '<input type="range" id="bst-' + key + '" data-bst-range="' + key + '" min="' + min + '" max="' + max + '" step="' + step + '" value="' + val + '">' +
      '<button type="button" class="bst-step-btn" data-bst-action="inc-' + key + '" aria-label="Increase ' + label.toLowerCase() + '">+</button></div></div>';
  }
  function onRange(input) {
    var key = input.getAttribute('data-bst-range'), v = +input.value, p = load();
    var imp = p.bodyUnit !== 'metric';
    p[key] = v; save(p);
    dlg.querySelector('#bst-' + key + '-out').textContent =
      key === 'h' ? fmtHeight(v, imp) : key === 'w' ? fmtWeight(v, imp) : fmtLen(v, p.measUnit === 'in' ? 'in' : 'cm');
  }
  function steps() { return byMeasure(load()) ? 2 : current.cat === 'dresses' ? 3 : 2; }

  function choice(action, title, sub) {
    return '<button type="button" class="bst-choice" data-bst-action="' + action + '"><span><strong>' + title +
      '</strong><small>' + sub + '</small></span><span aria-hidden="true">→</span></button>';
  }
  function viewFit() {
    return header('Find your size') +
      '<p class="bst-step">Step 2 of ' + steps() + '</p><h3 class="bst-q">How do you like your clothes to fit?</h3>' +
      choice('fit-fitted', 'Fitted', 'Close to the body') +
      choice('fit-regular', 'Regular', 'True to size, comfortable') +
      choice('fit-relaxed', 'Relaxed', 'A little looser and roomier') +
      (byMeasure(load()) ? '<button type="button" class="bst-link-btn" data-bst-action="measure">Change my measurements</button>'
        : '<button type="button" class="bst-link-btn" data-bst-action="find-edit">Change height &amp; weight</button>');
  }
  function viewHips() {
    return header('Find your size') +
      '<p class="bst-step">Step 3 of 3</p><h3 class="bst-q">How would you describe your hips?</h3>' +
      choice('hips-straight', 'Straighter', 'Narrower hips') +
      choice('hips-average', 'In proportion', 'In proportion with my waist') +
      choice('hips-fuller', 'Fuller', 'Fuller hips and bum') +
      '<button type="button" class="bst-link-btn" data-bst-action="back-fit">Back</button>';
  }
  function viewResult(p) {
    var r = recommend(current.prod, current.cat, p);
    var imp = p.bodyUnit !== 'metric';
    var size = r.row.size, value = r.row.value || size;
    current.result = { size: size, value: value };
    var mu = p.measUnit === 'in' ? 'in' : 'cm';
    var basis = (byMeasure(p) ? 'bust ' + fmtLen(p.b, mu) + ' · waist ' + fmtLen(p.wa, mu) + (p.hi ? ' · hips ' + fmtLen(p.hi, mu) : '')
      : fmtHeight(p.h, imp) + ' · ' + fmtWeight(p.w, imp)) + ' · ' + (FIT_LABEL[p.fit] || 'regular fit');
    var fitNote = r.shift === 1 ? 'This item runs small, so we’ve gone up a size. ' : r.shift === -1 ? 'This item runs large, so we’ve gone down a size. ' : '';
    var canAdd = !!findInput(value);
    track('size_result', { size: size, method: byMeasure(p) ? 'measurements' : 'height_weight' });
    cartNote({ 'Size finder': size + ' – ' + current.prod.title });
    return header('Find your size') +
      '<div class="bst-result"><p class="bst-result__label">Your size</p><p class="bst-result__size">' + esc(size) + '</p>' +
      '<p class="bst-result__uk">Fits UK ' + esc(String(r.row.uk).replace('-', '–')) + '</p></div>' +
      '<p class="bst-basis">Based on ' + basis + '.<br>' + fitNote +
      (r.closest ? 'This is the closest size we have for this item.' : 'Between sizes? We recommend the larger one.') + '</p>' +
      (canAdd ? '<button type="button" class="bst-btn" data-bst-action="add" data-bst-autofocus>Add size ' + esc(size) + ' to bag</button>' +
        '<button type="button" class="bst-link-btn" data-bst-action="select">Just select size ' + esc(size) + '</button>' : '') +
      '<p class="bst-status" role="status"></p>' +
      fitBar(current.prod) +
      '<button type="button" class="bst-link-btn" data-bst-action="' + (byMeasure(p) ? 'measure' : 'find-edit') + '">Edit my details</button>' +
      '<button type="button" class="bst-link-btn" data-bst-action="open-chart">View size chart</button>';
  }

  /* ---------- actions ---------- */
  function action(a, btn) {
    var p = load();
    if (a === 'close') return dlg.close();
    if (a === 'unit-cm' || a === 'unit-in') { p.chartUnit = a.slice(5); save(p); return render('chart'); }
    if (a === 'tab-measure' || a === 'tab-intl' || a === 'tab-item') { p.chartTab = a.slice(4); save(p); track('size_chart_tab', { tab: p.chartTab }); return render('chart'); }
    if (a === 'measure') { track('size_quiz_measure'); return render('measure'); }
    if (a === 'meas-cm' || a === 'meas-in') { p.measUnit = a.slice(5); save(p); return render('measure'); }
    if (a === 'measure-next') {
      p.b = +dlg.querySelector('#bst-b').value; p.wa = +dlg.querySelector('#bst-wa').value; p.hi = +dlg.querySelector('#bst-hi').value;
      p.mode = 'measure'; save(p);
      return render('fit');
    }
    if (a === 'open-chart') return render('chart');
    if (a === 'find') { track('size_quiz_start', { from: 'chart' }); return render(byMeasure(p) ? (p.b && p.wa ? 'fit' : 'measure') : (p.h && p.w ? 'fit' : 'body')); }
    if (a === 'find-edit') return render('body');
    if (a === 'body-metric' || a === 'body-imperial') { p.bodyUnit = a.slice(5); save(p); return render('body'); }
    if (/^(inc|dec)-/.test(a)) {
      var key = a.slice(4), input = dlg.querySelector('#bst-' + key);
      var imp = p.bodyUnit !== 'metric';
      var stepSize = key === 'h' ? (imp ? CM_PER_IN : 1) : key === 'w' ? (imp ? KG_PER_LB : 1) : (p.measUnit === 'in' ? CM_PER_IN / 2 : 1);
      input.value = Math.max(+input.min, Math.min(+input.max, +input.value + (a[0] === 'i' ? stepSize : -stepSize)));
      return onRange(input);
    }
    if (a === 'body-next') {
      p.h = +dlg.querySelector('#bst-h').value; p.w = +dlg.querySelector('#bst-w').value; p.mode = 'body'; save(p);
      return render('fit');
    }
    if (a === 'back-fit') return render('fit');
    if (/^fit-/.test(a)) { p.fit = a.slice(4); save(p); return render(current.cat === 'dresses' && !byMeasure(p) ? 'hips' : 'result'); }
    if (/^hips-/.test(a)) { p.hips = a.slice(5); save(p); return render('result'); }
    if (a === 'select' || a === 'add') {
      var target = targetVariant(current.result.value);
      var ok = selectSize(current.result.value);
      if (!ok) return status('Size ' + current.result.size + ' isn’t available in this colour.');
      track(a === 'add' ? 'size_add_to_bag' : 'size_select', { size: current.result.size });
      if (a === 'select') { dlg.close(); return; }
      cartNote({ 'Added with size finder': 'Yes' });
      btn.disabled = true;
      return waitForVariant(target, function () { addToBag(btn); });
    }
  }
  function status(msg) { var s = dlg.querySelector('.bst-status'); if (s) s.textContent = msg; }

  /* ---------- talking to the theme's size buttons ---------- */
  // Swatch King draws its own size buttons and hides the theme's; use whichever one shoppers see.
  function isSK(fs) { return !!fs.closest('.swatch-single'); }
  function sizeFieldset(root, prod) {
    var name = String(prod.sizeOption || 'size').toLowerCase();
    var sk = root.querySelectorAll('.swatch-single fieldset');
    for (var j = 0; j < sk.length; j++) {
      var nm = sk[j].querySelector('.swatch-option-name');
      if (nm && nm.textContent.trim().toLowerCase() === name && sk[j].closest('.swatch-single').getBoundingClientRect().width > 0) return sk[j];
    }
    var sets = root.querySelectorAll('fieldset.variant-option');
    for (var i = 0; i < sets.length; i++) {
      var inp = sets[i].querySelector('input[data-option-name]');
      if (inp && inp.getAttribute('data-option-name').toLowerCase() === name) return sets[i];
      var lg = sets[i].querySelector('legend');
      if (lg && lg.textContent.trim().toLowerCase().indexOf(name) === 0) return sets[i];
    }
    return null;
  }
  function findInput(value) {
    var fs = current && sizeFieldset(current.root, current.prod);
    if (!fs) return null;
    var opts = isSK(fs) ? fs.querySelectorAll('li.swatch-view-item') : fs.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < opts.length; i++) {
      var v = isSK(fs) ? opts[i].getAttribute('orig-value') : opts[i].value;
      if (v === value) return opts[i];
    }
    return null;
  }
  function unavailable(opt) {
    if (opt.tagName === 'INPUT') return opt.getAttribute('aria-disabled') === 'true' || opt.disabled;
    var b = opt.querySelector('.swatch-button') || opt;
    return /disabled|sold-?out|unavailable/i.test(opt.className + ' ' + b.className) || opt.getAttribute('aria-disabled') === 'true';
  }
  function selectSize(value) {
    var opt = findInput(value);
    if (!opt || unavailable(opt)) return false;
    if (opt.tagName === 'INPUT') { if (!opt.checked) opt.click(); }
    else if (opt.getAttribute('aria-checked') !== 'true') (opt.querySelector('.swatch-button') || opt).click();
    return true;
  }
  // The variant the shopper will get: their current colour etc. with the recommended size.
  function idInput() {
    var box = current.root.closest('.quick-add-modal__content, product-information, .product-details') || document;
    return box.querySelector('form[action*="/cart/add"] input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
  }
  function targetVariant(value) {
    var vs = current.prod.variants, inp = idInput();
    if (!vs || !inp || current.prod.sizeIndex == null) return null;
    var cur = vs.filter(function (v) { return String(v.id) === String(inp.value); })[0];
    if (!cur) return null;
    var want = cur.o.slice(); want[current.prod.sizeIndex] = value;
    return vs.filter(function (v) { return v.o.join('|') === want.join('|'); })[0] || null;
  }
  // Wait (up to 5 s) until the theme has switched its form to that variant, then add.
  function waitForVariant(target, done) {
    if (!target) return setTimeout(done, 900);
    var t0 = Date.now();
    (function check() {
      var inp = idInput();
      if (inp && String(inp.value) === String(target.id)) return setTimeout(done, 150);
      if (Date.now() - t0 > 5000) return done();
      setTimeout(check, 120);
    })();
  }
  function addToBag(btn) {
    var scope = current.root.closest('.product-details, product-information, .quick-add-modal__content, form') || document;
    var add = scope.querySelector('[id^="BuyButtons-ProductSubmitButton-"], add-to-cart-component button, button[name="add"]') ||
      document.querySelector('[id^="BuyButtons-ProductSubmitButton-"]');
    if (!add || add.disabled) { btn.disabled = false; return status('Couldn’t add to bag. Please use the Add to cart button.'); }
    dlg.close();
    add.click();
  }

  /* ---------- placing the links ---------- */
  var HANGER = '<svg aria-hidden="true" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 7a2 2 0 1 1 2-2c0 1-.8 1.4-1.4 1.8-.4.3-.6.6-.6 1.2v.5"/><path d="M12 8.5 3 15.2a1 1 0 0 0 .6 1.8h16.8a1 1 0 0 0 .6-1.8L12 8.5z"/></svg>';
  function place(script) {
    var prod;
    try { prod = JSON.parse(script.textContent); } catch (e) { return; }
    var cat = categoryOf(prod);
    if (cat === 'none' || !getCharts() || !getCharts()[cat]) return;
    var root = script.closest('.product-details, product-information, .quick-add-modal__content') || script.parentElement;
    function ensure() {
      var fs = sizeFieldset(root, prod);
      if (!fs) return;
      var lg = isSK(fs) ? fs.querySelector('.swatch-label-container') : fs.querySelector('legend');
      if (lg && !lg.querySelector('.bst-chart-link')) {
        var a = el('button', { type: 'button', class: 'bst-chart-link', text: 'Size Chart' });
        a.addEventListener('click', function (e) {
          e.preventDefault(); current = { prod: prod, cat: cat, root: root };
          var pp = load(); if (pp.chartTab === 'item' || garment(prod)) { pp.chartTab = garment(prod) ? 'item' : 'measure'; save(pp); }
          open('chart'); track('size_chart_open');
        });
        lg.appendChild(a);
      }
      if ((cat !== 'footwear' || prod.fit) && !(fs.nextElementSibling && fs.nextElementSibling.classList.contains('bst-find'))) {
        var wrap = el('div', { class: 'bst-find' });
        if (cat !== 'footwear') {
          var b = el('button', { type: 'button', class: 'bst-find__btn' });
          b.addEventListener('click', function (e) {
            e.preventDefault(); current = { prod: prod, cat: cat, root: root };
            var p = load();
            track('size_quiz_start', { from: 'product' });
            var hasBase = byMeasure(p) ? (p.b && p.wa) : (p.h && p.w);
            open(!hasBase ? (byMeasure(p) ? 'measure' : 'body') : !p.fit ? 'fit' : profileDone(p, cat) ? 'result' : 'hips');
          });
          wrap.appendChild(b);
        }
        if (prod.fit) wrap.insertAdjacentHTML('beforeend', fitBar(prod));
        fs.parentNode.insertBefore(wrap, fs.nextSibling);
      }
      var p = load(), btn = fs.parentNode.querySelector('.bst-find__btn');
      if (btn) {
        var label = 'Find my size';
        if (profileDone(p, cat)) label = 'Your size: <strong>' + esc(recommend(prod, cat, p).row.size) + '</strong>';
        if (btn.getAttribute('data-label') !== label) { btn.innerHTML = HANGER + '<span>' + label + '</span>'; btn.setAttribute('data-label', label); }
      }
      document.documentElement.classList.add('bst-on');
    }
    ensure();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(ensure, 60); }).observe(root, { childList: true, subtree: true });
    document.addEventListener('bst:profile', ensure);
  }
  function init() {
    document.querySelectorAll('script[data-bellisa-size-product]:not([data-bst-done])').forEach(function (s) {
      s.setAttribute('data-bst-done', '');
      place(s);
    });
  }
  // Refresh "Your size" labels whenever the quiz closes.
  document.addEventListener('close', function (e) {
    if (e.target === dlg) document.dispatchEvent(new Event('bst:profile'));
  }, true);

  window.BellisaSizeTools = { init: init, _test: { letterOf: letterOf, shoeOf: shoeOf, categoryOf: categoryOf, estimateUK: estimateUK, recommend: recommend, rowsFor: rowsFor, garment: garment, ukOfLabel: ukOfLabel, profileDone: profileDone, setCharts: function (c) { charts = c; } } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Quick-add pop-ups load products later.
  var it;
  new MutationObserver(function () { clearTimeout(it); it = setTimeout(init, 150); }).observe(document.documentElement, { childList: true, subtree: true });
})();
